import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/checkout/yuno-loading-spinner.svg")